import React from "react";

function Tooltip({ label, children }) {
  return (
    <span className="tooltip-wrapper">
      {children}
      <span className="tooltip-bubble" role="tooltip">
        {label}
      </span>
    </span>
  );
}

export default Tooltip;
